module.exports = __webpack_public_path__ + "assets/cheerup2.a2087cea.svg";